import { getCountryCodeISO } from "../../utils/general";

export function csvToArray(str, delimiter = ",") {
  const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
  const rows = str.slice(str.indexOf("\n") + 1).split("\n");
  if (rows && rows.length > 0) {
    if (rows[rows.length - 1] === "") {
      rows.splice(-1);
    }
  }
  if (!rows || rows.length === 0) {
    return [];
  }
  return rows.map(function (row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function (object, header, index) {
      object[header] = values[index];
      return object;
    }, {});
    return el;
  });
}

export function parseCsvUserIdsFromFile(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve([]);
      return;
    }
    const reader = new FileReader();
    reader.onload = function (event) {
      const textData = event.target.result;
      let arrFileData = csvToArray(textData);
      if (arrFileData.length === 0) {
        resolve([]);
        return;
      }
      arrFileData = arrFileData.map((element) =>
        Object.values(element)[0].replace(/(\r\n|\n|\r)/gm, "")
      );
      resolve(arrFileData);
    };
    reader.onerror = () => reject(reader.error || new Error("Failed to read CSV file"));
    reader.readAsText(file);
  });
}

export function stripHtmlToPlainText(html = "") {
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

/** Expiry date picker values use end of local day so same-day selection is not already expired. */
export function toNotificationExpiryEndOfDay(date) {
  if (!date) return null;
  const expiry = new Date(date);
  expiry.setHours(23, 59, 59, 999);
  return expiry.getTime();
}

export function isNotificationExpiryInFuture(expiryDateMs) {
  return Boolean(expiryDateMs && expiryDateMs > Date.now());
}

export function getNotificationExpiryUnixSeconds(expiryDateMs) {
  return Math.round(expiryDateMs / 1000);
}

/** Same single-select country list as Push Notification user selection. */
export function getNotificationCountrySelectOptions(allowedCountries = []) {
  return [
    { value: "None", label: "None" },
    ...(allowedCountries
      ?.filter((country) => getCountryCodeISO(country.toUpperCase()))
      .map((country) => {
        const code = getCountryCodeISO(country.toUpperCase());
        return { value: code, label: code };
      }) || []),
  ];
}
